import { useRef, useEffect } from "react";
import { Utils } from "../../common/views/Utils";
import { CustomerLevel, CustomerType } from "../models/CustomerModel";
import { useCustomerVM } from "../viewmodels/CustomerVM";

export default function CustomerProfile() {
    const hasLoaded = useRef(false);
    const vm = useCustomerVM();

    const width4 = Utils.getColumnWidth(4);
    const width8 = Utils.getColumnWidth(8);

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.get();
    }, [vm]);

    const printRow = (label: string, value: string) => {
        return <div className="ms-Grid-row">
            <div className={width4 + " left"}>{label}:</div>
            <div className={width8 + " right"}>{value}</div>
        </div>
    }

    const title = (text: string) => {
        return <div className="left primary-background-color font-bold p-10">
            {text}
        </div>
    }

    const loginInfo = () => {
        if (!vm.customer) return <></>;

        const customer = vm.customer;
        const user = customer.user;
        const phoneNo = user && user.countryCode && user.phoneNo
            ? Utils.formatKhPhone(user.countryCode, user.phoneNo) : "";

        return <div className="ph-10">
            <div className="pt-10">{printRow("Display Name", customer.displayName)}</div>
            <div className="pt-10">{printRow("Phone", phoneNo)}</div>
            <div className="pt-10">{printRow("Email", user?.email ?? "")}</div>
        </div>;
    }

    const personalInfo = () => {
        if (!vm.customer) return <></>;

        const customer = vm.customer;

        return <div className="ph-10">
            <div className="pt-10">{printRow("ID", customer.id.toString())}</div>
            <div className="pt-10">{printRow("Display Name", customer.displayName)}</div>
            <div className="pt-10">{printRow("Start", Utils.formatShortDate(customer.start))}</div>
            <div className="pt-10">{printRow("Type", Utils.toCapital(CustomerType[customer.type]))}</div>
            <div className="pt-10">{printRow("Level", Utils.toCapital(CustomerLevel[customer.level]))}</div>
            <div className="pt-10">{printRow("Invoice", customer.invoiceTotal.toFixed(2))}</div>
            <div className="pt-10">{printRow("Payment", customer.paymentTotal.toFixed(2))}</div>
            <div className="pt-10">{printRow("Balance", customer.balance.toFixed(2))}</div>
        </div>;
    }

    return <div className="ms-Grid pv-15">
        {title("Login Info")}
        {loginInfo()}

        <div className="pt-15">{title("Personal Info")}</div>
        {personalInfo()}
    </div>
}